import Vue from 'vue';

const success = (context, response) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal(context.$t('rentals.detail.modals.deleted_success'), response.msg, "success");
};

const failed = (context, error) => {
  swal("Error", context.$t('rentals.detail.modals.something_went_wrong'), "error");
  context.showToasterError(error);
};

export default (context, id) => {
  return Vue.$http.delete(`tasks/${id}`)
    .then(response => {
      success(context, response.data);
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/task/destroy.js